import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL, STORAGE_KEYS } from '../../constants';

export interface FrequentAddress {
  id: number;
  address: string;
  useCount: number;
  lastUsed: string;
  createdAt: string;
}

export const frequentAddressApi = createApi({
  reducerPath: 'frequentAddressApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_BASE_URL}`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['FrequentAddress'],
  endpoints: (builder) => ({
    getFrequentAddresses: builder.query<FrequentAddress[], { query?: string; limit?: number }>({
      query: (params) => ({
        url: '/frequent-addresses',
        method: 'GET',
        params: {
          query: params.query,
          limit: params.limit || 10,
          _ts: Date.now(),
        },
      }),
      providesTags: ['FrequentAddress'],
    }),
    addFrequentAddress: builder.mutation<FrequentAddress, { address: string }>({
      query: (body) => ({
        url: '/frequent-addresses',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['FrequentAddress'],
    }),
    deleteFrequentAddress: builder.mutation<{ success: boolean }, number>({
      query: (id) => ({
        url: `/frequent-addresses/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['FrequentAddress'],
    }),
  }),
});

export const {
  useGetFrequentAddressesQuery,
  useLazyGetFrequentAddressesQuery,
  useAddFrequentAddressMutation,
  useDeleteFrequentAddressMutation,
} = frequentAddressApi;

